export const bucketConfig = {
    slug: '0d951b90-a0a0-11ec-928c-59cc0d07db2d',
    read_key: 'skak78naIg5fui29J5XdqKdLKjnqrWEzENnCktJsag6c7Ibvxa'
}